import getSocket from 'services/getSocket';

let socket;

export const connect = (confirmToken, onLoginSuccess, onLoginRevoked) => {
  if (socket) {
    socket.disconnect();
  }
  socket = getSocket('loginConfirm', { confirmToken });
  // Socket auto-connects by default
  socket.on('confirm', ({ token, user, keepSessionOpen, loginMethod }) => {
    onLoginSuccess({ token, user, keepSessionOpen, loginMethod });
  });
  socket.on('revoke', () => {
    onLoginRevoked();
  });
  return socket;
};

export const disconnect = () => {
  if (socket) {
    socket.disconnect();
  }
};

export const handleOn = (name, callback) => {
  return (
    socket &&
    socket.on(name, data => {
      // console.log('WS on:', name, data);
      callback(data);
    })
  );
};

export const on = (name, callback) => {
  if (Array.isArray(name)) {
    return name.map(n => handleOn(n, callback));
  }

  return handleOn(name, callback);
};

export const isConnected = () => {
  return !!socket?.connected;
};
